/*eslint-disable*/ export const messages = JSON.parse("{\"textarea.label.optional\":[\"Optional\"]}");
//# sourceMappingURL=messages.mjs.map